const BOT_USERNAME = import.meta.env.VITE_TELEGRAM_BOT_USERNAME || 'tabletop_trail_bot';
const WEBAPP_SHORT_NAME = import.meta.env.VITE_TELEGRAM_WEBAPP_SHORTNAME || 'app';

/**
 * Direct link to the Mini App opened on the given event.
 * The `event_<id>` start param is handled by `parseDeepLink` in `deepLink.ts`.
 */
export function buildEventLink(eventId: string): string {
  return `https://t.me/${BOT_USERNAME}/${WEBAPP_SHORT_NAME}?startapp=event_${eventId}`;
}
